'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Embed = require('./Embed');

var _Embed2 = _interopRequireDefault(_Embed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Embed2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/dist/commonjs/modules/Embed/index.js
 ** module id = 1469
 ** module chunks = 0
 **/